import { ReactComponent as Delete } from '@public/icons/delete.svg';
import Icon from '../atoms/Icon';

const IconDelete = (props) => <Icon as={Delete} {...props} />;

IconDelete.propTypes = Icon.propTypes;

export default IconDelete;
